import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";

import {Entity, EntityKey} from "../../entity/entity";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {EntityService} from "../../services/entity-service";
import {firstValueFrom} from "rxjs";
import {StringUtils} from '../../utils/string-utils';
import {Router} from "@angular/router";
import {IecRiserProjectDefaultsComponent} from "./iec/iec-riser-project-defaults/iec-riser-project-defaults.component";
import {ClmRiserProjectDefaultsComponent} from "./clm/clm-riser-project-defaults/clm-riser-project-defaults.component";

@Component({
    selector: 'app-riser-project-defaults',
    imports: [FormsModule, MatProgressSpinner, IecRiserProjectDefaultsComponent, ClmRiserProjectDefaultsComponent],
    templateUrl: './riser-project-defaults.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './riser-project-defaults.component.css'
})
export class RiserProjectDefaultsComponent implements OnInit {
  private readonly entityService = inject(EntityService);
  private readonly router = inject(Router);


  readonly entityKey = input.required<EntityKey>();
  readonly errorEvent = output<any>();
  brand!: string;
  entity!: Entity;
  readonly isBusy = signal<boolean>(undefined!);

  ngOnInit(): void {
    this.isBusy.set(true);
    this.initializeData().then(() => this.isBusy.set(false), (error: any) => this.handleError(error));
  }

  private async initializeData(): Promise<void> {
    this.entity = await firstValueFrom<Entity>(this.entityService.getEntityByKey(this.entityKey()));
    this.brand = this.entity?.brandID || '';
    if (StringUtils.isBlank(this.brand)) {
      this.backToHome();
    }
  }

  private backToHome(): void {
    this.router.navigate(['/', 'main']).then(() => this.isBusy.set(false));
  }

  handleError(error: any) {
    this.errorEvent.emit(error);
  }

  isIEC(): boolean {
    return StringUtils.equalsIgnoreCase('IEC', this.brand);
  }

  isCLM(): boolean {
    return StringUtils.equalsIgnoreCase('CLM', this.brand);
  }

}
